module.exports = "/lucky-balls/img/weager/balls/color/black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/black.png
// module id = 1176
// module chunks = 0